// Node
const $ = require('jquery');

// Custom
import ApartmentsFormDesktop from 'new_design/common/search_widget/search_form/apartments/desktop';
import { assigning_responsible } from "../../../common/responsible_parameters";

$(document).ready(function () {
  ApartmentsFormDesktop.init('search-form-apartments', { lazyLoad: $('#apartments_data *').length === 0 });
  assigning_responsible();
});
